import React from 'react';
import './TourCta.scss';

const TourCta = () => {
return (
    <section className="sec-tour-cta">
    <div className="TourCTA">
        <div className="box-main">
        <h2 className="cta-title">캠퍼스 투어 신청하기</h2>
        <p className="cta-desc">
            GIST 캠퍼스를 직접 방문하여 미래를 체험해보세요.
            <br />
            지온나래 홍보대사가 여러분의 방문을 환영합니다.
        </p>
        <div className="box-actions">
            <a
            href="https://www.gist.ac.kr/kr/html/sub01/010308.html"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
            >
            견학 신청하기
            </a>
        </div>
        <p className="cta-notice">
            * 신청은 GIST 공식 페이지로 연결됩니다.
        </p>
        </div>
    </div>
    </section>
);
};

export default TourCta;